module.exports = __webpack_public_path__ + "static/media/empty.91661969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/empty.svg
// module id = 1299
// module chunks = 0